/**
 * JadEye Landing Page App Entry Point
 *
 * 회사 홈페이지 (jadeye.net) 전용 진입점
 * - 기존 SPA (/web/*) 와 분리
 * - 모던 미니멀 디자인
 */

import '../css/app.css';
import { mount } from 'svelte';
import LandingApp from './pages/Landing/LandingApp.svelte';

// Landing App 마운트 (라우터 포함)
const target = document.getElementById('landing-app');

if (target) {
    mount(LandingApp, { target });
    console.log('🌟 JadEye Landing App mounted successfully!');
} else {
    console.error('❌ Landing app mount target not found');
}
